(function () {
  'use strict';

  if (window.__pakhorCartLoaded) return;
  window.__pakhorCartLoaded = true;

  var DRAWER_SECTION = 'cart-drawer-pakhor';
  var PAGE_SECTION = 'main';
  var drawerEl = null;
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function qsa(sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  }

  function getDrawer() {
    if (!drawerEl) drawerEl = document.getElementById('PakhorCartDrawer');
    return drawerEl;
  }

  function formatMoney(cents) {
    if (window.Pakhor && typeof window.Pakhor.formatMoney === 'function') {
      return window.Pakhor.formatMoney(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function updateCartCount(count) {
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) n = 0;
    qsa('[data-cart-count]').forEach(function (badge) {
      badge.textContent = String(n);
      if (n === 0) badge.setAttribute('data-empty', '');
      else badge.removeAttribute('data-empty');
    });
  }

  function refreshCartCountBadge() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') {
          updateCartCount(cart.item_count);
        }
        return cart;
      })
      .catch(function () {});
  }

  function subtotalFromDom() {
    var sum = 0;
    qsa('[data-line-cents]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-line-cents'), 10);
      if (!isNaN(cents) && cents > 0) sum += cents;
    });
    return sum;
  }

  function sumLineItems(items) {
    if (!items || !items.length) return 0;
    return items.reduce(function (sum, item) {
      var line = Number(item.final_line_price);
      if (!line || isNaN(line)) {
        line = Number(item.line_price);
      }
      if (!line || isNaN(line)) {
        line = Number(item.original_line_price);
      }
      if (!line || isNaN(line)) {
        line = (Number(item.price) || 0) * (Number(item.quantity) || 0);
      }
      return sum + (line || 0);
    }, 0);
  }

  function cartSubtotal(cart) {
    if (!cart) return subtotalFromDom();
    var fromLines = sumLineItems(cart.items);
    if (fromLines > 0) return fromLines;
    var subtotal = Number(cart.items_subtotal_price);
    if (!isNaN(subtotal) && subtotal > 0) return subtotal;
    var total = Number(cart.total_price);
    if (!isNaN(total) && total > 0) return total;
    var original = Number(cart.original_total_price);
    if (!isNaN(original) && original > 0) return original;
    return subtotalFromDom();
  }

  function updateSubtotals(cart) {
    if (!cart) return;
    var subtotal = cartSubtotal(cart);
    qsa('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(subtotal);
    });
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pk-cart-drawer-open');
    qsa('[data-cart-drawer-open], .pakhor-header__cart').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pk-cart-drawer-open');
    qsa('[data-cart-drawer-open], .pakhor-header__cart').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function sectionsUrl() {
    if (document.querySelector('[data-cart-page-form]')) {
      return root() + 'cart';
    }
    return window.location.pathname || '/';
  }

  function sectionsToRequest() {
    var sections = [DRAWER_SECTION];
    if (document.querySelector('[data-cart-page-form]')) {
      sections.push(PAGE_SECTION);
    }
    return sections;
  }

  function refreshCartPage() {
    if (!document.querySelector('[data-cart-page-form]')) return Promise.resolve();
    return fetch(root() + 'cart?section_id=' + encodeURIComponent(PAGE_SECTION))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        applySectionHtml(PAGE_SECTION, html);
      })
      .catch(function () {
        return fetch(root() + 'cart?sections=' + encodeURIComponent(PAGE_SECTION))
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.sections) applySectionHtml(PAGE_SECTION, data.sections[PAGE_SECTION]);
          });
      });
  }

  function setRowBusy(key, busyState) {
    if (!key) return;
    qsa('[data-cart-item][data-key="' + key + '"]').forEach(function (row) {
      if (busyState) row.setAttribute('aria-busy', 'true');
      else row.removeAttribute('aria-busy');
    });
  }

  function parseSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.shopify-section') || doc.body.firstElementChild;
  }

  function applySectionHtml(sectionKey, html) {
    if (!html) return;

    if (sectionKey === DRAWER_SECTION) {
      var drawer = getDrawer();
      var target = drawer && drawer.querySelector('[data-cart-drawer-contents]');
      if (!target) return;
      var parsed = parseSectionHtml(html);
      target.innerHTML = parsed ? parsed.innerHTML : html;
      populateUpsell();
      return;
    }

    if (sectionKey === PAGE_SECTION) {
      var parsedPage = parseSectionHtml(html);
      var current = document.querySelector('.pk-cart-page');
      var incoming = parsedPage && parsedPage.querySelector('.pk-cart-page');
      if (current && incoming) current.innerHTML = incoming.innerHTML;
    }
  }

  function applySectionsFromCartResponse(cart) {
    if (!cart || !cart.sections) return;
    Object.keys(cart.sections).forEach(function (key) {
      applySectionHtml(key, cart.sections[key]);
    });
    if (cart.items && cart.items.length) {
      updateLinePrices(cart);
    } else {
      updateSubtotals(null);
    }
  }

  function refreshDrawer() {
    return fetch(root() + 'cart?section_id=' + encodeURIComponent(DRAWER_SECTION))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        applySectionHtml(DRAWER_SECTION, html);
        updateSubtotals(null);
      })
      .catch(function () {
        return fetch(root() + 'cart?sections=' + encodeURIComponent(DRAWER_SECTION))
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (data.sections) applySectionHtml(DRAWER_SECTION, data.sections[DRAWER_SECTION]);
          });
      })
      .then(function () {
        return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateSubtotals(cart);
            updateLinePrices(cart);
            return cart;
          });
      });
  }

  function normalizeOptionValue(value) {
    return String(value == null ? '' : value).trim();
  }

  function variantOptions(v) {
    var opts = [];
    if (v.option1 != null && v.option1 !== '') opts.push(normalizeOptionValue(v.option1));
    if (v.option2 != null && v.option2 !== '') opts.push(normalizeOptionValue(v.option2));
    if (v.option3 != null && v.option3 !== '') opts.push(normalizeOptionValue(v.option3));
    if (!opts.length && v.options && v.options.length) {
      v.options.forEach(function (o) {
        var val = normalizeOptionValue(o);
        if (val) opts.push(val);
      });
    }
    return opts;
  }

  function optionsMatchSelection(vOpts, selected) {
    if (!selected.length || !vOpts.length) return false;
    if (vOpts.length !== selected.length) return false;
    for (var i = 0; i < selected.length; i++) {
      if (normalizeOptionValue(vOpts[i]) !== normalizeOptionValue(selected[i])) return false;
    }
    return true;
  }

  function getSelectedOptionsFromForm(form) {
    var selected = [];
    form.querySelectorAll('.pdp__option').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked:not(:disabled)');
      if (checked) selected.push(normalizeOptionValue(checked.value));
    });
    if (!selected.length) {
      var sparse = [];
      var maxIndex = -1;
      form.querySelectorAll('[data-option-index]:checked').forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        if (isNaN(idx)) return;
        sparse[idx] = normalizeOptionValue(input.value);
        if (idx > maxIndex) maxIndex = idx;
      });
      if (maxIndex >= 0) {
        selected = [];
        for (var i = 0; i <= maxIndex; i++) selected[i] = sparse[i] || '';
      }
    }
    return selected;
  }

  function resolveVariantFromForm(form) {
    if (!form) return null;
    var rootEl = form.closest('[data-pdp-root]');
    if (!rootEl) return null;
    var jsonEl = rootEl.querySelector('[data-pdp-variants]');
    if (!jsonEl) return null;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }

    var selected = getSelectedOptionsFromForm(form);

    if (!selected.length) {
      var fallbackInput = form.querySelector('[data-variant-id], [name="id"]');
      return fallbackInput ? String(fallbackInput.value) : null;
    }

    var match = variants.find(function (v) {
      return optionsMatchSelection(variantOptions(v), selected);
    });

    if (!match) return null;

    var variantInput = form.querySelector('[data-variant-id], [name="id"]');
    if (variantInput) variantInput.value = String(match.id);
    return String(match.id);
  }

  function updateLinePrices(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item) {
      qsa('[data-line-price="' + item.key + '"]').forEach(function (el) {
        el.textContent = formatMoney(item.final_line_price);
        el.setAttribute('data-line-cents', String(item.final_line_price || 0));
      });
      qsa('[data-cart-qty-input][data-key="' + item.key + '"]').forEach(function (input) {
        input.value = item.quantity;
      });
    });
    updateSubtotals(cart);
  }

  function cartChange(body) {
    if (busy) return Promise.resolve();
    busy = true;

    var payload = Object.assign({}, body, {
      sections: sectionsToRequest(),
      sections_url: sectionsUrl(),
    });

    function postChange(data) {
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(data),
      }).then(function (res) {
        return res.json();
      });
    }

    return postChange(payload)
      .then(function (data) {
        if (data && typeof data.status !== 'undefined' && Number(data.status) >= 400) {
          throw new Error(data.description || data.message || 'Cart update failed');
        }
        if (data && data.message && !data.items) {
          throw new Error(data.description || data.message || 'Cart update failed');
        }
        return data;
      })
      .catch(function () {
        return postChange(body);
      })
      .then(function (data) {
        if (data && typeof data.status !== 'undefined' && Number(data.status) >= 400) {
          throw new Error(data.description || data.message || 'Cart update failed');
        }
        updateCartCount(data.item_count);
        applySectionsFromCartResponse(data);
        if (!data.sections || !data.sections[DRAWER_SECTION]) {
          updateLinePrices(data);
        }
        var refreshPromise = Promise.resolve(data);
        if (document.querySelector('[data-cart-page-form]') && (!data.sections || !data.sections[PAGE_SECTION])) {
          refreshPromise = refreshCartPage().then(function () { return data; });
        }
        return refreshPromise.then(function (cartData) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData, bubbles: true }));
          return cartData;
        });
      })
      .finally(function () {
        busy = false;
      });
  }

  function getKeyFromEl(el) {
    if (!el) return null;
    return el.getAttribute('data-key') || null;
  }

  function getQtyForKey(key) {
    var input = qsa('[data-cart-qty-input]').find(function (el) {
      return el.getAttribute('data-key') === key;
    });
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  function changeLine(key, quantity) {
    if (!key) return Promise.resolve();
    setRowBusy(key, true);
    return cartChange({ id: key, quantity: Math.max(0, quantity) })
      .catch(showError)
      .finally(function () {
        setRowBusy(key, false);
      });
  }

  function changeLineDelta(key, delta) {
    var next = getQtyForKey(key) + delta;
    return changeLine(key, next);
  }

  function showError(err) {
    window.alert((err && err.message) || 'Could not update cart. Please try again.');
  }

  /* ---------- Added-to-cart toast ---------- */
  function showToast(message) {
    var host = document.getElementById('DialogRoot') || document.body;
    var toast = document.createElement('div');
    toast.className = 'pk-cart-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="pk-cart-toast__check" aria-hidden="true">&#10003;</span>' +
      '<span class="pk-cart-toast__msg"></span>';
    toast.querySelector('.pk-cart-toast__msg').textContent = message || 'Added to cart';
    host.appendChild(toast);
    requestAnimationFrame(function () {
      toast.setAttribute('data-show', '');
    });
    window.setTimeout(function () {
      toast.removeAttribute('data-show');
      window.setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 320);
    }, 2400);
  }

  /* ---------- Drawer upsell (related product recommendations) ---------- */
  function renderUpsellItem(product) {
    var variant = null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { variant = variants[i]; break; }
    }
    if (!variant) variant = variants[0];
    if (!variant) return '';

    var img = product.featured_image || (product.images && product.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img = img.indexOf('?') > -1 ? img + '&width=160' : img + '?width=160';

    var price = formatMoney(variant.price);
    var imgHtml = img
      ? '<img class="pk-upsell__img" src="' + img + '" alt="" loading="lazy" width="56" height="56">'
      : '<span class="pk-upsell__img pk-upsell__img--empty"></span>';

    return (
      '<div class="pk-upsell">' +
      '<a class="pk-upsell__media" href="' + (product.url || '#') + '" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
      '<div class="pk-upsell__info">' +
      '<a class="pk-upsell__title" href="' + (product.url || '#') + '">' + (product.title || '') + '</a>' +
      '<span class="pk-upsell__price">' + price + '</span>' +
      '</div>' +
      '<button type="button" class="pk-upsell__add" data-upsell-add data-variant-id="' + variant.id + '" aria-label="Add ' + (product.title || 'item') + ' to cart">Add</button>' +
      '</div>'
    );
  }

  function populateUpsell() {
    var wrap = document.querySelector('[data-cart-upsell]');
    var list = document.querySelector('[data-cart-upsell-list]');
    if (!wrap || !list) return;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          wrap.hidden = true;
          return;
        }
        var inCart = cart.items.map(function (i) { return i.product_id; });
        var seedId = cart.items[0].product_id;
        return fetch(
          root() + 'recommendations/products.json?product_id=' + seedId + '&limit=6&intent=related',
          { headers: { Accept: 'application/json' } }
        )
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.products || []).filter(function (p) {
              return inCart.indexOf(p.id) === -1;
            }).slice(0, 2);
            if (!products.length) {
              wrap.hidden = true;
              return;
            }
            list.innerHTML = products.map(renderUpsellItem).join('');
            wrap.hidden = false;
          });
      })
      .catch(function () {
        wrap.hidden = true;
      });
  }

  function addVariant(variantId, btn) {
    if (!variantId || busy) return;
    busy = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionsToRequest(),
        sections_url: sectionsUrl(),
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && Number(data.status) >= 400) {
          throw new Error(data.description || data.message || 'Add failed');
        }
        applySectionsFromCartResponse(data);
        return fetch(root() + 'cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateSubtotals(cart);
        openDrawer();
        showToast('Added to cart');
      })
      .catch(showError)
      .finally(function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  }

  function onDocumentClick(e) {
    var drawer = getDrawer();

    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.target.closest('[data-cart-qty-minus]')) {
      e.preventDefault();
      e.stopPropagation();
      changeLineDelta(getKeyFromEl(e.target.closest('[data-cart-qty-minus]')), -1);
      return;
    }

    if (e.target.closest('[data-cart-qty-plus]')) {
      e.preventDefault();
      e.stopPropagation();
      changeLineDelta(getKeyFromEl(e.target.closest('[data-cart-qty-plus]')), 1);
      return;
    }

    if (e.target.closest('[data-cart-remove]')) {
      e.preventDefault();
      e.stopPropagation();
      changeLine(getKeyFromEl(e.target.closest('[data-cart-remove]')), 0);
      return;
    }

    var upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      e.stopPropagation();
      addVariant(upsellBtn.getAttribute('data-variant-id'), upsellBtn);
      return;
    }

    var cardAtcBtn = e.target.closest('[data-card-add-to-cart]');
    if (cardAtcBtn) {
      e.preventDefault();
      e.stopPropagation();
      addVariant(cardAtcBtn.getAttribute('data-variant-id'), cardAtcBtn);
      return;
    }

    if (e.target.closest('.pk-cart-drawer__view-cart')) {
      closeDrawer();
      return;
    }

    var cartBtn = e.target.closest('[data-cart-drawer-open], .pakhor-header__cart');
    if (cartBtn) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      refreshDrawer();
      return;
    }
  }

  function onDocumentChange(e) {
    if (e.target.matches('[data-cart-qty-input]')) {
      var key = getKeyFromEl(e.target);
      var qty = parseInt(e.target.value, 10);
      if (key && !isNaN(qty)) changeLine(key, qty);
    }
  }

  function bindAddToCartForms() {
    qsa('[data-pakhor-add]').forEach(function (form) {
      if (form.dataset.cartBound) return;
      form.dataset.cartBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var pdpRoot = form.closest('[data-pdp-root]');
        var hasOptionSelection = !!form.querySelector(
          '.pdp__option input[type="radio"]:checked:not(:disabled), [data-option-index]:checked:not(:disabled)'
        );
        var variantId = resolveVariantFromForm(form);

        if (!variantId && window.PakhorPdp && typeof window.PakhorPdp.syncVariant === 'function') {
          window.PakhorPdp.syncVariant(pdpRoot || form);
          variantId = resolveVariantFromForm(form);
        }

        if (!variantId) {
          var variantInput = form.querySelector('[data-variant-id], [data-qs-variant-id], [name="id"]');
          if (variantInput && (!hasOptionSelection || !pdpRoot)) {
            variantId = String(variantInput.value);
          }
        }

        if (!variantId) {
          if (hasOptionSelection && pdpRoot) {
            window.alert('Please select a size.');
          }
          return;
        }

        variantId = parseInt(variantId, 10);
        if (!variantId) return;

        var btn = form.querySelector('[data-pdp-atc], [type="submit"]');
        var qtyInput = form.querySelector('[data-qty-input], [name="quantity"]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }

        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }],
            sections: sectionsToRequest(),
            sections_url: window.location.pathname || '/',
          }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (data.status && Number(data.status) >= 400) {
              throw new Error(data.description || data.message || 'Add failed');
            }
            applySectionsFromCartResponse(data);
            return fetch(root() + 'cart.js');
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            updateSubtotals(cart);
            openDrawer();
            showToast('Added to cart');
          })
          .catch(function (err) {
            window.alert((err && err.message) || 'Could not add to cart.');
          })
          .finally(function () {
            if (btn) {
              btn.disabled = false;
              btn.removeAttribute('aria-busy');
            }
          });
      });
    });
  }

  function init() {
    drawerEl = getDrawer();
    bindAddToCartForms();
    refreshCartCountBadge().then(function (cart) {
      if (cart) updateSubtotals(cart);
    });

    if (window.Pakhor && typeof window.Pakhor.on === 'function') {
      window.Pakhor.on('cart:updated', function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') {
          updateCartCount(cart.item_count);
        }
        updateSubtotals(cart);
      });
    }

    window.PakhorCart = {
      open: function () {
        openDrawer();
        return refreshDrawer();
      },
      close: closeDrawer,
      refresh: refreshDrawer,
      changeLine: changeLine,
    };

    /* Wrap (do NOT clobber) base.js's dialog manager so the size guide,
       search, and other dialogs keep working. Only the cart drawer is
       routed to this controller's open/refresh. */
    window.Pakhor = window.Pakhor || {};
    window.Pakhor.dialog = window.Pakhor.dialog || {};
    if (!window.Pakhor.dialog.__pakhorCartWrapped) {
      var originalOpen = window.Pakhor.dialog.open;
      window.Pakhor.dialog.open = function (el, opts) {
        var isCart =
          el === '.pakhor-cart-drawer' ||
          (el && el.classList && el.classList.contains('pakhor-cart-drawer')) ||
          (el && el.id === 'PakhorCartDrawer');
        if (isCart) {
          openDrawer();
          refreshDrawer();
          return;
        }
        if (typeof originalOpen === 'function') {
          return originalOpen.call(window.Pakhor.dialog, el, opts);
        }
      };
      window.Pakhor.dialog.__pakhorCartWrapped = true;
    }
  }

  if (!window.__pakhorCartEventsBound) {
    window.__pakhorCartEventsBound = true;
    document.addEventListener('click', onDocumentClick, false);
    document.addEventListener('change', onDocumentChange, false);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
